import 'twin.macro';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string;
  className?: string;
}

export function CustomFieldTitle(props: Props) {
  const { title, className } = props;
  const { t } = useTranslation('common');

  if (!title || title === '') {
    return null;
  }
  return (
    <span className={className} tw="font-bold break-words">
      {t(`common:labels.${title}`, {
        defaultValue: title,
      })}
      &nbsp;:
    </span>
  );
}
